import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminUserSearchCriteria } from '../../models/admin-user-search-criteria';
import { AdminUserSearchResult } from '../../models/admin-user-search-result';
import { TableResponse } from '../../models/table-response';
import { TableRequestData } from '../../models/table/table-request-param';

type AdminUserSearchRequest = AdminUserSearchCriteria &
  Omit<TableRequestData, 'filters'>;

@Injectable()
export class AdminUserApi {
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/admin/uzytkownicy';

  searchUsers$(
    criteria: AdminUserSearchCriteria,
    tableRequest: TableRequestData,
  ): Observable<TableResponse<AdminUserSearchResult>> {
    const { filters, ...requestParams } = tableRequest;
    const hasLastLoginAtFilter = Object.prototype.hasOwnProperty.call(
      filters ?? {},
      'lastLoginAt',
    );
    const request: AdminUserSearchRequest = {
      ...criteria,
      ...requestParams,
      lastLoginAt: hasLastLoginAtFilter
        ? (filters?.['lastLoginAt']?.toString() ?? null)
        : (criteria.lastLoginAt ?? null),
    };

    return this.#httpClient.post<TableResponse<AdminUserSearchResult>>(
      `${this.#apiUrl}/search`,
      request,
      { withCredentials: true },
    );
  }
}
